import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/* global console, process, require, window, Map */

@Injectable()
export class ApiService {
  private apiUrl;
  private menu$!: Observable<any>;
  private units$!: Observable<any>;

  constructor(@Inject(HttpClient) private httpClient: HttpClient) {
    this.apiUrl = window.api_url;
  }

  getMenu(): Observable<any> {
    if (!this.menu$ || window.api_url !== this.apiUrl) {
      this.apiUrl = window.api_url;
      let url = window.api_url + '/feeder/menue_new';
      this.menu$ = this.httpClient.get(url).pipe(shareReplay(1));
    }
    return this.menu$;
  }

  getUnits(): Observable<any> {
    if (!this.units$) {
      let url = window.api_url + '/feeder/units';
      this.units$ = this.httpClient.get(url).pipe(shareReplay(1));
    }
    return this.units$;
  }

  generateTimeSeries(
    begin: string,
    end: string,
    resolution: string,
    additional_info: boolean,
    country_code: string,
    timezone: string,
    date_format: string
  ): Observable<any> {
    let url = window.api_url + '/utility/generate_time_series?';
    if (additional_info !== undefined) {
      url += 'additional_info=' + additional_info;
    } else {
      url += 'additional_info=' + false;
    }
    if (begin !== undefined && begin !== null && begin !== '') {
      url += '&begin=' + encodeURIComponent(begin);
    }
    if (end !== undefined && end !== null && end !== '') {
      url += '&end=' + encodeURIComponent(end);
    }
    if (resolution !== undefined && resolution !== null && resolution !== '') {
      url += '&resolution=' + resolution;
    }
    if (
      country_code !== undefined &&
      country_code !== null &&
      country_code !== ''
    ) {
      url += '&country_code=' + country_code;
    }
    if (date_format === 'UTC') {
      url += '&utc_and_local=false';
    } else if (date_format === 'Local') {
      url += '&utc_and_local=false';
    } else if (date_format === 'Local & UTC') {
      url += '&utc_and_local=true';
    }
    if (date_format !== 'UTC') {
      if (timezone !== '') {
        url += '&time_zone=' + encodeURIComponent(timezone);
      }
    }
    return this.httpClient.get(url);
  }
}
